import './ccf-phone-outline-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfPhoneOutlineIconProps  extends SvgIconProps {}

/**
 * CcfPhoneOutlineIcon used to disply phone ouline icon in the contact card panel
 * @param props - CcfPhoneOutlineIconProps
 * @example -- <CcfPhoneOutlineIcon />
 */
export function CcfPhoneOutlineIcon(props: CcfPhoneOutlineIconProps) {
  return (
    <SvgIcon {...props}>
        <g id="Action_Call" clipPath="url(#clip-Action_Call)">
          <path id="outbound" d="M-.045,3.356A8.069,8.069,0,0,0,.59,6.09a16.724,16.724,0,0,0,3.7,5.5,16.743,16.743,0,0,0,5.442,3.678c1.018.394,3.231,1.128,4.152.21.01-.015.02-.025.03-.04l1.656-1.911a1.331,1.331,0,0,0,.344-.888,1.41,1.41,0,0,0-.01-.145,1.516,1.516,0,0,0-.424-.913.6.6,0,0,0-.06-.055L13.047,9.649a1.334,1.334,0,0,0-.913-.359,1.31,1.31,0,0,0-.948.39.454.454,0,0,0-.09.1l-.638.958c-.334-.08-1.3-.576-3.048-2.325S5.156,5.7,5.081,5.368l.953-.639a.977.977,0,0,0,.1-.09A1.345,1.345,0,0,0,6.17,2.778L4.3.409a.711.711,0,0,0-.055-.06A1.421,1.421,0,0,0,2.3.264L.4,1.921c-.015.01-.025.02-.04.03A1.844,1.844,0,0,0-.09,3.169a1.355,1.355,0,0,0,0,.14ZM3.263,1.387h0L5.1,3.7l-.938.619a.526.526,0,0,0-.055.035,1.17,1.17,0,0,0-.434.868C3.654,5.57,3.6,6.613,6.422,9.44c.693.694,2.818,2.821,4.211,2.749a1.2,1.2,0,0,0,.873-.434q.02-.03.04-.055l.619-.938,2.309,1.831v0l-1.606,1.846c-.628.3-4.31-.594-7.6-3.877S1.087,3.593,1.4,2.969Z" transform="translate(4.09 3.08)"/>
        </g>
    </SvgIcon>
  );
}

export default CcfPhoneOutlineIcon;
